

// Sort items with favorited === true (descending by accessDt)
export const sortFavoritedByAccessDateDesc = (response) => {
  const list = Array.isArray(response) ? response : [];
  const isFav = (v) => v === true || v === 'true' || v === 1 || v === '1';
  const toNum = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };
  return list
    .filter((item) => isFav(item?.favorited))
    .sort((a, b) => toNum(b?.accessDt) - toNum(a?.accessDt));
};

  // Sort by accessDt (descending)
export const sortByAccessDateDesc = (list) => {
  const toEpochMs = (v) => {
    if (v == null) return 0;
    const n = Number(v);
    if (Number.isFinite(n)) return n < 10_000_000_000 ? n * 1000 : n; // seconds -> ms
    const t = new Date(v).getTime();
    return Number.isNaN(t) ? 0 : t;
  };
  return Array.isArray(list)
    ? [...list].sort((a, b) => toEpochMs(b?.accessDt) - toEpochMs(a?.accessDt))
    : [];
};

// Count reports in the top 3 recently reviewed (sorted by accessDt descending)
export const countTop3RecentlyReviewed = (list) => {
  const arr = Array.isArray(list) ? list : [];
  return sortByAccessDateDesc(arr).slice(0, 3).length;
};